import React from 'react';
import { VStack, StackDivider } from '@chakra-ui/react';
import { Button, Icon } from '@chakra-ui/react';
import { ChevronRight } from 'react-feather';
import { useModalDispatch } from '@olo-web/client-state';
import { EModalTypes } from '@olo-web/types/enums';
import { ContentCard } from '@olo-web/components/atoms/ContentCard';
import { useIsSplitByAmount } from '@olo-web/utils/common/hooks/useIsSplitByAmount';
export function CheckoutBagContainer({
  children,
  showDivider,
  contentTitle = 'Your Order',
  ...rest
}: {
  children: JSX.Element | JSX.Element[];
  showDivider?: boolean;
  contentTitle?: string;
  [key: string]: any;
}): JSX.Element {
  const modalDispatch = useModalDispatch();
  const isSplitByAmount = useIsSplitByAmount();
  const handleClick = (): void => {
    modalDispatch({
      type: 'OPEN_MODAL',
      payload: {
        modalKey: isSplitByAmount ? EModalTypes.ORDER_DETAILS : EModalTypes.ORDERED_ITEMS,
      },
    });
  };

  return (
    <ContentCard
      title={contentTitle}
      rightTitleAdornment={
        <Button
          data-testid="view-items-checkout-button"
          variant="tertiary"
          colorScheme="black"
          fontWeight="600"
          mr={-5}
          onClick={handleClick}
          rightIcon={<Icon as={ChevronRight} h={5} w={5} ml={-1} />}
        >
          {isSplitByAmount ? 'View order' : 'View Items'}
        </Button>
      }
      headerContainerFlexProps={{
        flexDir: 'row',
        align: 'center',
      }}
      titleDescriptionFlexProps={{
        mb: 0,
      }}
      {...rest}
    >
      <VStack
        spacing={4}
        w="100%"
        divider={showDivider ? <StackDivider borderColor="gray.200" /> : null}
      >
        {children}
      </VStack>
    </ContentCard>
  );
}
